export const ALLOCATIONS_ROLES = ["Allocations.Viewer", "Allocations.Editor"] as const;

export type AllocationsViewerRole = (typeof ALLOCATIONS_ROLES)[number];

export function hasAnyOfRoles(userRoles: string[], allowedRoles: readonly string[]): boolean {
  if (import.meta.env.DEV) return true;
  if (userRoles.length === 0 || allowedRoles.length === 0) return false;
  return userRoles.some((role) => allowedRoles.includes(role));
}
